












































import { Component, Vue, Prop } from 'vue-property-decorator'
import LoginContent from '@/components/gambling/LoginContent.vue'
import LoginEmailBtn from '@/components/gambling/LoginEmailBtn.vue'
import Cashier from '@/components/Cashier'
import { Action, Mutation } from 'vuex-class'

@Component({
  components: {
    LoginContent,
    LoginEmailBtn,
    Cashier
  }
})

export default class HomePageOne extends Vue {
  @Action('reloadCashier') reloadCashier: any
  @Mutation('setAccountType') setAccountType: any

  @Prop({ type: Boolean, required: false }) isAuthenticated!: boolean
  @Prop({ type: Function, required: false }) setLogInModal!: void
  @Prop({ type: Function, required: false }) makeDeposit!: void
  @Prop({ type: String, required: false }) currencyCode!: string
  @Prop({ type: String, required: false }) fullName!: string

  $cashierConfigs!: any
  $smallScreen!: boolean
  $routeChange!: any

  private toDepositNow (): void {
    this.setAccountType('banking')
    this.reloadCashier({ method: 'deposit' })
    this.$routeChange('/gambling/account')
  }

  private created () {
    this.$cashierConfigs('bankingPageFlow', {
      showHeader: !this.$smallScreen
    })
  }
}
